import projectDashboard from './reducer';

export enum Type {
  FETCH_PROJECT_DASHBOARD_DATA = 'PROJECT_DASHBOARD/FETCH_PROJECT_DASHBOARD_DATA',
}

interface Action<T> {
  type: T;
}

export interface FetchProjectDashboardData
  extends Action<Type.FETCH_PROJECT_DASHBOARD_DATA> {}

export const actions = {
  fetchProjectDashboardData: (): FetchProjectDashboardData => ({
    type: Type.FETCH_PROJECT_DASHBOARD_DATA,
  }),
};

export { projectDashboard };
